module.exports = __webpack_public_path__ + "static/img/5.935b80f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_image/5.jpg
// module id = beGY
// module chunks = 39